module.exports = {
	AccelerometerEvent: require("./AccelerometerEvent").default,
	ActivityEvent: require("./ActivityEvent").default,
	AsyncErrorEvent: require("./AsyncErrorEvent").default,
	DataEvent: require("./DataEvent").default,
	ErrorEvent: require("./ErrorEvent").default,
	Event: require("./Event").default,
	EventDispatcher: require("./EventDispatcher").default,
	EventPhase: require("./EventPhase").default,
	FocusEvent: require("./FocusEvent").default,
	FullScreenEvent: require("./FullScreenEvent").default,
	GameInputEvent: require("./GameInputEvent").default,
	HTTPStatusEvent: require("./HTTPStatusEvent").default,
	IEventDispatcher: require("./IEventDispatcher").default,
	IOErrorEvent: require("./IOErrorEvent").default,
	KeyboardEvent: require("./KeyboardEvent").default,
	MouseEvent: require("./MouseEvent").default,
	NetStatusEvent: require("./NetStatusEvent").default,
	ProgressEvent: require("./ProgressEvent").default,
	RenderEvent: require("./RenderEvent").default,
	SampleDataEvent: require("./SampleDataEvent").default,
	SecurityErrorEvent: require("./SecurityErrorEvent").default,
	TextEvent: require("./TextEvent").default,
	TimerEvent: require("./TimerEvent").default,
	TouchEvent: require("./TouchEvent").default,
	UncaughtErrorEvent: require("./UncaughtErrorEvent").default,
	UncaughtErrorEvents: require("./UncaughtErrorEvents").default,
	VideoTextureEvent: require("./VideoTextureEvent").default,
}